/**
 * @generated SignedSource<<0d5f604612bf89ee40f0d00060f06b40>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "email"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "email",
        "variableName": "email"
      }
    ],
    "concreteType": "SendPasswordResetPayload",
    "kind": "LinkedField",
    "name": "sendPasswordReset",
    "plural": false,
    "selections": [
      {
        "kind": "InlineFragment",
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "success",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "notice",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "needsAuthentication",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "ValidationError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "field",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "messages",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "type": "MutationResult",
        "abstractKey": "__isMutationResult"
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "SendPasswordResetMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "SendPasswordResetMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "fedae60ed1121aac7822218a813d8df6",
    "id": null,
    "metadata": {},
    "name": "SendPasswordResetMutation",
    "operationKind": "mutation",
    "text": "mutation SendPasswordResetMutation(\n  $email: String!\n) {\n  sendPasswordReset(email: $email) {\n    ... on MutationResult {\n      __isMutationResult: __typename\n      success\n      notice\n      needsAuthentication\n      errors {\n        field\n        messages\n      }\n    }\n  }\n}\n"
  }
};
})();

node.hash = "87f8999cecbfb58353eb96c66230c360";

module.exports = node;
